import React from 'react';
import {
	MDBRow as Row,
	MDBCol as Col,
	MDBContainer as Container
} from 'mdbreact';
import Product from '../Product';

const Products = () => {
	return (
		<section id='products' style={{ position: 'relative', top: '-150px' }}>
			<Container>
				<Row>
					<Col>
						<h1
							data-aos='fade-up'
							data-aos-delay='50'
							style={{ color: '#FF6701' }}
							className='h1-responsive font-weight-bold mt-5 text-center text-uppercase'>
							Products
						</h1>
						<p
							data-aos='fade-up'
							data-aos-delay='200'
							className='lead grey-text w-responsive mx-auto mb-5 text-center'>
							Anong hanap mo, suki? Meron kami niyan!
						</p>
					</Col>
				</Row>
				<Row className='mt-5'>
					<Col
						data-aos='fade-right'
						data-aos-delay='350'
						md='6'
						className='mb-4'>
						<Product
							title='Meat & Seafood'
							description='Indulge in our wide array of different cuts of farm-direct meat and an assortment of fresh, frozen, and dried seafood.'
							img='meat.jpg'
							className='mb-4'
						/>
					</Col>
					<Col
						data-aos='fade-left'
						data-aos-delay='500'
						md='6'
						className='mb-4'>
						<Product
							title='Vegetables'
							description='We offer a variety of leafy greens, mushrooms, herbs, root crops, and a collection of lettuces and cabbages.'
							img='vegetable.jpg'
							className='mb-4'
						/>
					</Col>
					<Col
						data-aos='fade-right'
						data-aos-delay='650'
						md='6'
						className='mb-4'>
						<Product
							title='Fruits'
							description='Choose from our selection of locally sourced citrus, berries, melons, and many more.'
							img='fruits.jpg'
							className='mb-4'
						/>
					</Col>
					<Col
						data-aos='fade-left'
						data-aos-delay='800'
						md='6'
						className='mb-4'>
						<Product
							title='Groceries'
							description='Tick off items on your grocery list and restock your fridge with eggs, condiments, canned goods and other perishable and non-perishable food products.'
							img='grocery.png'
							className='mb-4'
						/>
					</Col>
				</Row>
			</Container>
		</section>
	);
};
export default Products;
